import { format, parse } from 'date-fns';

const STORED_FORMAT = 'yyyy-MM-dd';
const DISPLAY_FORMAT = 'd MMM yyyy';

/**
 * A day that parses clean, or null where there is none.  A two-digit year is
 * refused, since the parser would otherwise read "15 Aug 26" as the year 26.
 */
function toDay(text: string, fromFormat: string): Date | null {
  const day = parse(text, fromFormat, new Date());
  return Number.isNaN(day.getTime()) || day.getFullYear() < 1000 ? null : day;
}

/**
 * The day an API date carries, as the plain yyyy-MM-dd the form stores.  The
 * API sends dates as date-times at a fixed UTC midnight, so the day is read
 * from the date part rather than parsed to the viewer's clock, where a summer
 * evening could shift it a day early.
 */
export function toDayInput(value: string | null): string | null {
  if (!value) return null;
  const day = toDay(value.slice(0, 10), STORED_FORMAT);
  return null === day ? null : format(day, STORED_FORMAT);
}

/**
 * A day as it reads in a row or field, e.g. "15 Aug 2026".
 */
export function formatDayInput(value: string | null): string | null {
  if (!value) return null;
  const day = toDay(value.slice(0, 10), STORED_FORMAT);
  return null === day ? null : format(day, DISPLAY_FORMAT);
}

/**
 * A day as typed, e.g. "15 Aug 2026", stored as the plain yyyy-MM-dd the form
 * keeps.  Null where blank or not a day the parser recognises.
 */
export function parseDayInput(text: string | null): string | null {
  if (!text) return null;
  const day = toDay(text.trim(), DISPLAY_FORMAT);
  return null === day ? null : format(day, STORED_FORMAT);
}
